import * as customerInfoActions from '../../actions/customer-info-actions/customer-info-actions';
import axios from 'axios';
import { history } from '../../history';
import * as types from '../../actions/actionTypes';
import * as constants from '../../../constants/constants';
import { getToken } from '../aws/token';

const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT || 'https://apidmz.fpl.com';
// 'http://localhost:8080';
let token = getToken() || null;
let REQUEST_TYPE = 'application/json';
let sendEmailEndpoint = `${API_ENDPOINT}/v1/surety-bond/sendemail`;
let authHeader =
  'Authorization, Origin, X-Requested-With, content-Type, Accept';

export const getCustomerInfo = (billAccount, taxId, authToken) => {
  console.log(billAccount, taxId, token);
  let token1 = authToken || getToken();
  let config = {
    headers: {
      'Content-Type': REQUEST_TYPE,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': authHeader,
      billAccount: billAccount,
      taxId: taxId,
      Authorization: `Bearer ` + token1,
    },
  };
  return dispatch => {
    dispatch({
      type: types.SET_REMOVE_ERROR,
    });
    dispatch(customerInfoActions.setCustomerInfo(true));
    axios
      .post(`${API_ENDPOINT}/v1/surety-bond/customer/validate`, '', config)
      .then(response => {
        dispatch(
          customerInfoActions.setCustomerInfoSuccess(false, response.data),
        );
        history.push('/info');
      })
      .catch(error => {
        console.log('customerinfo-service error-1', error);
        console.log('customerinfo-service error', error.response);
        if (error.response.status >= 500) {
          dispatch(
            customerInfoActions.setErrorPage(
              false,
              'Service is temporarily down, Please try agian later : ERR:NCP-CIS-RET-SERV-DOWN ',
            ),
          );
          history.push('/error');
        }
        if (error.response.status === 409) {
          dispatch(
            customerInfoActions.setErrorPage(
              false,
              'Service is temporarily down, Please try agian later : ERR:NCP-DB-DOWN',
            ),
          );
          history.push('/error');
        } else if (error.status === 401) {
          history.push('/logout');
        } else if (error.response.data.message !== undefined) {
          dispatch(
            customerInfoActions.setCustomerInfoError(
              false,
              error.response.data.message,
            ),
          );
        } else {
          dispatch(
            customerInfoActions.setCustomerInfoError(
              false,
              error.response.data,
            ),
          );
        }
      });
  };
};

export const getPendingApplicationInfo = authToken => {
  let token1 = authToken || getToken();
  let config = {
    headers: {
      'Content-Type': REQUEST_TYPE,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': authHeader,
      Authorization: `Bearer ` + token1,
    },
    crossorigin: true,
  };
  return dispatch => {
    dispatch({
      type: types.SET_REMOVE_ERROR,
    });
    dispatch(customerInfoActions.setCustomerInfo(true));
    axios
      .get(`${API_ENDPOINT}/v1/surety-bond/customer/info/all`, config)
      .then(response => {
        dispatch(
          customerInfoActions.setCustomerInfoSuccess(false, response.data),
        );
      })
      .catch(error => {
        if (
          error.status === 500 ||
          error.status === 409 ||
          error.status === 504 ||
          error.status === 401
        ) {
          dispatch(
            customerInfoActions.setErrorPage(
              false,
              ' ERR:NCP-GET-ALL-SERV-DOWN',
            ),
          );
          history.push('/error');
        } else if (
          error.response !== undefined &&
          error.response.data !== undefined
        ) {
          dispatch(
            customerInfoActions.setCustomerInfoError(
              false,
              error.response.data.message,
            ),
          );
        }
      });
  };
};

export const removeSaveError = () => {
  return dispatch => {
    dispatch({ type: types.SET_REMOVE_ERROR });
  };
};

export const setCustomerInfo = (payload, authToken) => {
  let token1 = authToken || getToken();
  let config = {
    headers: {
      'Content-Type': REQUEST_TYPE,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': authHeader,
      Authorization: `Bearer ` + token1,
    },
    crossorigin: true,
  };
  return dispatch => {
    dispatch({ type: types.SET_REMOVE_ERROR });
    dispatch(customerInfoActions.setCustomerInfo(true));
    axios
      .post(
        `${API_ENDPOINT}/v1/surety-bond/customer/info/save`,
        payload,
        config,
      )
      .then(response => {
        dispatch(
          customerInfoActions.setCustomerInfoSuccess(false, response.data),
        );
        history.push('/submitSuccess');
        return axios
          .all([
            axios.post(
              sendEmailEndpoint,
              {
                subject: constants.depAdminSubject(
                  payload.district,
                  payload.status,
                ),
                templateName: constants.DEPOSIT_ADMIN_EMAIL_TEMPLATE_NAME,
                bondNumber: payload.bondNumber,
                billAccount: payload.billAccount,
                companyName: payload.profile.companyName,
                district: payload.district,
                status: payload.status,
                emailAddress: constants.DepsoitAdminEmail,
              },
              config,
            ),
          ])
          .then(
            axios.spread((firstResponse, secondResponse, thirdResponse) => {
              console.log(
                firstResponse.data,
                secondResponse.data,
                thirdResponse.data,
              );
            }),
          );
      })

      .catch(error => {
        // console.log('in service',error);
        if (
          error &&
          error.response !== undefined &&
          error.response.status !== undefined &&
          error.response.status === 503
        ) {
          dispatch(
            customerInfoActions.setErrorPage(false, ' ERR:NCP-AG-SAVE-DOWN'),
          );
          history.push('/error');
        } else if (
          error &&
          error.response !== undefined &&
          error.response.status !== undefined &&
          error.response.status === 409
        ) {
          dispatch(customerInfoActions.setErrorPage(false, ' ERR:NCP-DB-DOWN'));
          history.push('/error');
          dispatch(
            customerInfoActions.setCustomerInfoError(
              false,
              error.response.data,
            ),
          );
        } else if (
          error &&
          error.response !== undefined &&
          error.response.status !== undefined &&
          error.response.status === 500
        ) {
          dispatch(
            customerInfoActions.setErrorPage(false, ' ERR:NCP-AG-SAVE-DOWN'),
          );
          history.push('/error');
          dispatch(
            customerInfoActions.setCustomerInfoError(
              false,
              error.response.data,
            ),
          );
        } else if (
          error &&
          error.response !== undefined &&
          error.response.status !== undefined &&
          error.response.status === 400
        ) {
          dispatch(
            customerInfoActions.setCustomerInfoError(
              false,
              error.response.data.message,
            ),
          );
        }
      });
  };
};
